import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from '../../services/global.service';

import { ActivatedRoute, Router } from '@angular/router';
import { ConstantHandler } from '../../handlers/constant-handler';
import { AlertHandler } from '../../handlers/alert-handler';
import { MessageHandler } from '../../handlers/message-handler';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/auth/services/auth.service';
import { CommonHandler } from '../../handlers/common-handler';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public userFullName: string;
  public userRole: string;
  public user_roles: any;
  public date: Date = new Date();

  public isActiveIcon: string;
  public isActiveUrl: boolean;

  // Remove Below Code Later
  public ssoEnabled = environment.ssoEnabled;
  public isSupportLinkEnabled = false;
  public isHomeLinkEnabled = false;

  /**
   * Creates an instance of AppHeader.
   * @param {AuthenticationService} authenticationService
   * @memberof AppHeader
   */
  constructor(
    private translate: TranslateService,
    public globalService: GlobalService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private authService: AuthService,
    private spinner: NgxSpinnerService
  ) {
    this.router.events.subscribe((val) => {
      this.isActiveUrl = this.router.url.indexOf('/landing') > 0 ? false : true;
    });
  }

  ngOnInit() {
    this.userFullName = this.globalService.user.fullname || this.globalService.user.username;
    this.userRole = this.globalService.user.roles && this.globalService.user.roles.length > 0 ? this.globalService.user.roles[0].role_description : null;
    this.user_roles = this.globalService.user.roles.filter((role) => role.type == 'landing');
    this.globalService.selectedGlobalParamater.subscribe((res) => {
      if (res) {
        this.isActiveIcon = res['show_menu_icon'];
      }
    });
  }

  ngAfterViewInit() {
    // TODO: Enable This Code if Change Password is enabled.
    // if (!this.globalService.user.security_question_id && this.globalService.getLocalStorageItem('SECURITY_QUESTION_UPDATED') == null
    //   && this.globalService.globalParams['security_question_disabled'] == null) {
    //   setTimeout(() => {
    //     this.openChangeSecurityQADialog();
    //   }, 0);
    // }
  }

  ngOnDestroy() {
    this.dialog.closeAll();
  }

  /**
   * Action when a user logs out.
   *
   * @memberof AppHeader
   */
  logout() {
    this.spinner.show();
    this.authService.logout({}).subscribe(
      (result) => {
        this.spinner.hide();
        // if (result && result.response == "SUCCESS") {
        if (environment.msalEnabled) {
          this.globalService.deleteUserSession();
          this.router.navigate(['auth/msl-logout']);
        } else if (environment.enabledBaseHref) {
          this.globalService.deleteUserSession();
          window.location.replace(window.location.origin);
        } else {
          this.router.navigate(['auth/login']);
          this.globalService.deleteUserSession();
        }
        // } else {
        //   AlertHandler.ErrorAlert(result.message);
        //   this.router.navigate(['auth/login']);
        //   this.globalService.deleteUserSession();
        // }
      },
      (error) => {
        this.spinner.hide();
        if (environment.msalEnabled) {
          this.globalService.deleteUserSession();
          this.router.navigate(['auth/msl-logout']);
        } else if (environment.enabledBaseHref) {
          this.globalService.deleteUserSession();
          window.location.replace(window.location.origin);
        } else {
          this.router.navigate(['auth/login']);
          this.globalService.deleteUserSession();
        }
        // AlertHandler.ErrorAlert(MessageHandler.INTERNAL_ERROR);
      }
    );
  }

  /**
   * Toggle fullscreen view for the page
   *
   * @memberof AppHeader
   */
  toggleFullscreen() {
    if (document['fullScreen'] || document['mozFullScreen'] || document['webkitIsFullScreen']) {
      this._hideFullScreen();
    } else {
      this._showFullScreen();
    }
  }

  /**
   * Show full screen for the page
   *
   * @private
   * @memberof AppHeader
   */
  private _showFullScreen() {
    const elem: any = document.documentElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  /**
   * Toggle fullscreen back to normal window size
   *
   * @private
   * @memberof AppHeader
   */
  private _hideFullScreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
  }

  public navigateToHome() {
    if (environment.enabledBaseHref) {
      window.location.replace(window.location.origin + '/app/landing')
    } else if (!this.ssoEnabled) {
      this.router.navigate(['app']);
    }
  }

  dropdownOpen = false;
  toggleDropdown(event: MouseEvent): void {
    event.preventDefault(); // prevent href="#" from reloading the page
    this.dropdownOpen = !this.dropdownOpen;
  }

  public goToMyProfile() {
    if (environment.enabledBaseHref) {
      window.location.replace(window.location.origin + '/app/my-profile')
    } else {
      this.router.navigate(['app/my-profile']);
    }
  }

  public goToPrivacyStatement() {
    if (this.router.url.indexOf('privacy') > -1)
      this.router.navigate(['app/privacy']);
    else
      window.open("app/privacy", '_blank');
  }

  selectTool(route: any) {
    this.router.navigate(['app' + route]);
  }

  public goToUserGuide() {
    if (this.router.url.indexOf('user-guide') > -1)
      this.router.navigate(['app/user-guide']);
    else
      window.open("app/user-guide", '_blank');
  }

  public goToTrainingVideo() {
    this.router.navigate(['app/training-video']);
  }
}
